{
  "general": {
    "required": "Обов'язкове поле",
    "incorrect-credentials": "Неправильне ім'я користувача або пароль."
  },

  "password": {
    "min-length": "Пароль повинен складати принаймні 8 символів",
    "password-match": "Паролі повинні співпадати",
    "requirements": "Пароль повинен складати принаймні 8 символів і містити 1 велику літеру та 1 малу літеру."
  },

  "email": {
    "invalid-format": "Неправильний формат"
  }
}
